exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-cc70815e] {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    margin: 0 auto;\n    -moz-column-gap: 10px;\n         column-gap: 10px;\n    row-gap: 10px;\n}\n.wrapper div[data-v-cc70815e] {\n    padding: 10px;\n    background: blue;\n    color: #fff;\n    text-align: center;\n}\n", ""]);

// exports
